import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import YoutubeSetupPage from "../app/YoutubeSetupPage";
import CustomerAccountPage from "../app/CustomerAccountPage";
import PageIndexPage from "../app/PageIndexPage";
import User from "~/models/User";
import ConstantStore from "~/stores/ConstantStore";
import PageActionPage from "../app/PageActionPage";
import ToastMessageStore from "~/stores/ToastMessageStore";

function CustomerProfileRoutes({ constantStore, user, toastMessageStore }) {
  return (
    <>
      <Route
        exact
        path="(/profile/account)"
        render={props => (
          <CustomerAccountPage
            {...props}
            constantStore={constantStore}
            user={user}
            toastMessageStore={toastMessageStore}
          />
        )}
      />
      <Route exact path="/profile/youtube" render={props => <YoutubeSetupPage {...props} user={user} />} />
      <Route
        exact
        path="/profile/pages"
        render={props => <PageIndexPage {...props} user={user} toastMessageStore={toastMessageStore} />}
      />
      <Route
        exact
        path="/profile/pages/create"
        render={props => (
          <PageActionPage
            {...props}
            isEdit={false}
            isToursPage={false}
            user={user}
            toastMessageStore={toastMessageStore}
          />
        )}
      />
      <Route
        exact
        path="/profile/pages/edit/tours"
        render={props => (
          <PageActionPage {...props} isEdit isToursPage user={user} toastMessageStore={toastMessageStore} />
        )}
      />
      <Route
        exact
        path="/profile/pages/edit/:pageId(\d+)"
        render={props => (
          <PageActionPage {...props} isEdit isToursPage={false} user={user} toastMessageStore={toastMessageStore} />
        )}
      />
    </>
  );
}

CustomerProfileRoutes.propTypes = {
  constantStore: PropTypes.instanceOf(ConstantStore),
  user: PropTypes.instanceOf(User),
  toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
};

export default CustomerProfileRoutes;
